export default (list, item) => (Array.isArray(list) ? list.filter((x) => x !== item) : list);